/* Joyoneer / Advertiser Phase 1. See ../README.md for contract and removal. */
(() => {
  'use strict';
  const parameter = 'joy_ad_product';
  const pinParameters = [parameter, 'featured'];
  const initial = new URL(window.location.href);
  if (!pinParameters.some(key => initial.searchParams.has(key))) return;
  const handle = initial.searchParams.has(parameter) ? initial.searchParams.get(parameter) : initial.searchParams.get('featured');

  const configNode = document.querySelector('[data-joy-ad-collection]');
  if (!configNode || configNode.dataset.initialized) return;
  configNode.dataset.initialized = 'true';
  const config = JSON.parse(configNode.textContent);
  const section = configNode.closest('[data-section-type="collection"]');
  let grid = section?.querySelector('#CollectionLoop');
  if (!grid) return;
  let stopped = false;
  let pinned = null;
  let placeholder = null;
  let original = null;
  let observer = null;
  const controller = new AbortController();
  const handleOf = card => {
    const link = card.querySelector('[data-product-link]');
    if (!link) return null;
    return new URL(link.href, window.location.origin).pathname.match(/\/products\/([^/]+)\/?$/)?.[1];
  };
  const cards = () => [...grid.children].filter(node => node.matches('[data-grid-item]'));
  const stripPin = url => { pinParameters.forEach(key => url.searchParams.delete(key)); return url; };
  // Shopify generates these from the original request. A page navigation is the native list.
  const preparePagination = () => section.querySelectorAll('.pagination-custom a[href]').forEach(link => {
    const url = stripPin(new URL(link.href));
    url.searchParams.delete('section_id');
    // Shopify's pagination URLs omit arbitrary attribution parameters. Carry
    // them forward without overriding the customer's native page/sort/filter.
    for (const [key, value] of initial.searchParams) {
      if (pinParameters.includes(key) || key === 'page' || key === 'sort_by' || key === 'section_id' || key.startsWith('filter.')) continue;
      if (!new URL(link.href).searchParams.has(key)) url.searchParams.append(key, value);
    }
    link.href = url.href;
  });
  preparePagination();
  const stop = () => {
    if (stopped) return;
    stopped = true;
    controller.abort();
    observer?.disconnect();
    if (pinned?.parentNode === grid) {
      pinned.remove();
      if (placeholder?.parentNode === grid) placeholder.replaceWith(original);
    }
    placeholder?.remove();
    const url = stripPin(new URL(window.location.href));
    window.history.replaceState(window.history.state, '', url);
    section.removeEventListener('click', onClick, true);
    section.removeEventListener('input', onInput, true);
    section.removeEventListener('change', onInput, true);
    section.removeEventListener('theme:range:update', stop, true);
    window.removeEventListener('popstate', stop);
  };
  const onClick = event => {
    if (event.target.closest('[data-sort-link], [data-filter-update-url], .pagination-custom a')) stop();
  };
  const onInput = event => {
    if (event.target.matches('[name^="filter."], [name="sort_by"]')) stop();
  };
  section.addEventListener('click', onClick, true);
  section.addEventListener('input', onInput, true);
  section.addEventListener('change', onInput, true);
  section.addEventListener('theme:range:update', stop, true);
  window.addEventListener('popstate', stop);

  if (!handle || !/^[a-z0-9][a-z0-9_-]{0,200}$/.test(handle)) return;
  if (config.page !== 1) return;
  if (initial.searchParams.has('page') && initial.searchParams.get('page') !== '1') return;
  if ([...initial.searchParams.keys()].some(key => key.startsWith('filter.'))) return;
  if (initial.searchParams.getAll('sort_by').some(sort => sort !== 'best-selling')) return;

  const endpoint = new URL(`${initial.pathname.replace(/\/$/, '')}/products/${encodeURIComponent(handle)}`, initial.origin);
  endpoint.searchParams.set('view', 'joy-ad-card');
  // Explicit theme previews must fetch the matching draft renderer.
  if (initial.searchParams.has('preview_theme_id')) endpoint.searchParams.set('preview_theme_id', initial.searchParams.get('preview_theme_id'));
  fetch(endpoint, { signal: controller.signal, credentials: 'same-origin' })
    .then(response => response.ok ? response.text() : '')
    .then(async html => {
      if (stopped || !grid.isConnected) return;
      const result = new DOMParser().parseFromString(html, 'text/html');
      const wrapper = result.querySelector('[data-joy-ad-card]');
      const rendered = wrapper?.querySelector('[data-grid-item]');
      // Liquid verifies collection membership, online availability, and the native hidden-card rules.
      if (wrapper?.dataset.handle !== handle || !rendered || handleOf(rendered) !== handle) return;
      if (config.sort !== 'best-selling') {
        const outer = section.querySelector('[data-products-grid]');
        if (!outer || !section.dataset.sectionId) return;
        const sortedUrl = stripPin(new URL(initial));
        sortedUrl.searchParams.set('sort_by', 'best-selling');
        sortedUrl.searchParams.set('section_id', section.dataset.sectionId);
        const response = await fetch(sortedUrl, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) return;
        const sorted = new DOMParser().parseFromString(await response.text(), 'text/html');
        const sortedConfig = JSON.parse(sorted.querySelector('[data-joy-ad-collection]')?.textContent || 'null');
        const sortedOuter = sorted.querySelector('[data-products-grid]');
        if (stopped || !grid.isConnected || sortedConfig?.handle !== config.handle || sortedConfig.page !== 1 || sortedConfig.sort !== 'best-selling' || !sortedOuter?.querySelector('#CollectionLoop')) return;
        // Keep Broadcast's existing controller/container; only native result markup is replaced.
        const fresh = document.importNode(sortedOuter, true);
        fresh.querySelectorAll('[data-aos]').forEach(node => node.removeAttribute('data-aos'));
        outer.replaceChildren(...fresh.childNodes);
        grid = outer.querySelector('#CollectionLoop');
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', 'best-selling');
        window.history.replaceState(window.history.state, '', url);
        const sort = section.querySelector('[data-sort-enabled]');
        if (sort) {
          sort.classList.add('is-active');
          const best = sort.querySelector('[data-sort-link][data-value="best-selling"]');
          const label = sort.querySelector('[data-sort-button-text]');
          if (label && best) label.textContent = best.textContent.trim();
          sort.querySelectorAll('[data-sort-link]').forEach(link => {
            link.parentElement.classList.toggle('is-active', link === best);
            if (link === best) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
          const input = sort.querySelector('[name="sort_by"]');
          if (input) { input.value = 'best-selling'; input.disabled = false; }
        }
        preparePagination();
      }
      const existing = cards().find(card => handleOf(card) === handle);
      if (existing) {
        placeholder = document.createComment('joy-ad-product original position');
        // Never reconnect an initialized Broadcast custom element: its quick-add
        // connectedCallback registers anonymous listeners on every connection.
        original = existing.cloneNode(true);
        pinned = existing.cloneNode(true);
        existing.replaceWith(placeholder);
      } else {
        pinned = document.importNode(rendered, true);
      }
      // Inserted cards must be visible without rerunning page animation initialization.
      pinned.querySelectorAll('[data-aos]').forEach(node => node.removeAttribute('data-aos'));
      pinned.removeAttribute('data-aos');
      grid.prepend(pinned);
      const deduplicate = () => {
        if (stopped || !grid.contains(pinned)) return;
        cards().forEach(card => { if (card !== pinned && handleOf(card) === handle) card.remove(); });
      };
      deduplicate();
      observer = new MutationObserver(deduplicate);
      observer.observe(grid, { childList: true });
    })
    .catch(() => { /* A failed lookup leaves the original server-rendered collection usable. */ });
})();
